import { ButtonBase, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMplTicketCard = styled(ButtonBase)(({ theme }) => ({
	width: '100%',
	boxSizing: 'border-box',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	gap: 8,
	padding: 12,
	borderRadius: 8,
	backgroundColor: theme.palette.neutral?.main ?? '#FFFFFF',
	border: `0.5px solid ${theme.palette.solutions?.[600] ?? '#66758F'}`,
	textAlign: 'left',
	'&:hover': {
		backgroundColor: 'rgba(0, 0, 0, 0.02)',
	},
	'&:active': {
		backgroundColor: 'rgba(0, 0, 0, 0.04)',
	},
}));

export const StyledMplTicketCardContent = styled(Stack)({
	flex: 1,
	minWidth: 0,
	gap: 1,
});

export const StyledMplTicketCardChevron = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: theme.palette.primary.main,
	flexShrink: 0,
}));
